import React,{Component} from 'react';
import './CreateClientLocaton.css';
import searchbule from '../../../image/searchbule.svg'
import iconlocationlg from '../../../image/iconlocationlg.svg'
import MapsNewOrder from '../Maps/MapsNewOrder';

class CreateClientLocaton extends Component{
    render(){
        return(
            <div className="CreateCientLocation">
               <form onSubmit={this.props.handleSubmitCreateLocation}>
                   
            
               <div className="col-12 text-center ">
               <MapsNewOrder key={this.props.state.res_done}  setStatecoordinatesaddress_alias={this.props.setStatecoordinatesaddress_alias} state={this.props.state} />

               <div className="col-lg-8 text-center">
                        <div className="form-group pb-0 mb-1 search_div"id="pac-container">
                        <img className="mr-1  img_input" src={searchbule} alt="search"  />
                            <input type="text " id="pac-input" className={"px-5 search_input mb-1 form-control badge-pill " + (this.props.state.address_nameError ? 'is-invalid' : '')} placeholder="Location" name="address_name" value={this.props.state.address_name} onChange={this.props.handleChange} required/>
                                  
                        </div>
                        <div style={{ fontSize: 12, color: "red" }} className="text-left">
                            {this.props.state.address_nameError}
                        </div> 
                        <div id="map"></div>
                        <div className="form-group col-12 text-left mt-2">
                        <label >Adrress Details</label>
                        <input type="text" className={"form-control badge-pill p-3 " + (this.props.state.address_aliasError ? 'is-invalid' : '')} placeholder="Adrress Details" name="address_alias" value={this.props.state.address_alias} onChange={this.props.handleChange} required />
                        <div style={{ fontSize: 12, color: "red" }}>
                            {this.props.state.address_aliasError}
                        </div>                
                    </div>
                    </div> 
               </div>

                <button type="submit" className="text-white badge-pill p-2 pl-1 px-3 border shadow bluebg text-center m-3" disabled={(this.props.state.inRequest?true:false)}>create</button>
                </form>
            </div>
        )
    }
}
export default CreateClientLocaton;